<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-6"
        :placeholder="$t('name')"
        :label="$t('name')"
        help="Este es el nombre del Widget con el que se mostrará en los listados"
        :v="$v.value.name"
        v-model="value.name"
      />
      <LmTextInput
        class="col-6"
        :placeholder="$t('title')"
        :label="$t('title')"
        help="Este es el título del gráfico"
        :v="$v.value.title"
        v-model="value.title"
      />
    </b-row>
    <b-row>
      <LmTreeSelect
        class="col-12"
        label="Calcular"
        :options="calculateOptions"
        :v="$v.value.calculate"
        v-model="value.calculate"
        @input="onCalculateChange"
      />
      <LmTreeSelect
        class="col-12"
        label="Origen de datos"
        :pathToGetOptions="sourcePath"
        :v="$v.value.dataOrigin"
        v-model="value.dataOrigin"
      />
      <LmTextInput
        class="col-md-6"
        placeholder="Icono"
        label="Icono"
        help="Este es el icono del contador"
        v-model="value.icon"
      />
      <div class="col-12 mb-2">
        <b-link href="https://materialdesignicons.com/" target="_blank">Catálogo de iconos</b-link>
      </div>
      <LmCheckbox
        class="col-12"
        :title="$t('available_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_in')"
        type="multiple"
        :options="availableInOptions"
        v-model="value.availableIn"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required } from 'vuelidate/lib/validators'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

export default {
  components: {
    LmTextInput,
    LmCheckbox,
    LmTreeSelect
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      availableInOptions: [
        {
          text: 'Bandeja de Entradas',
          value: 'inbox'
        },
        {
          text: 'Dashboard',
          value: 'dashboard'
        }
      ],
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ],
      calculateOptions: [
        {
          id: 'count',
          name: 'Cantidad'
        },
        {
          id: 'average',
          name: 'Tiempo promedio',
          sources: ['documents']
        },
        {
          id: 'max',
          name: 'Tiempo máximo',
          sources: ['documents']
        },
        {
          id: 'min',
          name: 'Tiempo mínimo',
          sources: ['documents']
        },
        {
          id: 'trees_saved',
          name: 'Árboles salvados',
          sources: ['documents']
        },
        {
          id: 'water_saved',
          name: 'Agua ahorrada',
          sources: ['documents']
        },
        {
          id: 'reams_saved',
          name: 'Resmas ahorradas',
          sources: ['documents']
        }
      ],
      sourcePath: '/datatables/all'
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      title: {
        required
      },
      dataOrigin: {
        required
      }
    }
  },
  methods: {
    onCalculateChange (event) {
      let params = ''
      if (event?.sources) {
        const source = event.sources.join(',')
        params = '?source=' + source
      }
      this.sourcePath = '/datatables/all' + params
      this.value.dataOrigin = null
    }
  },
  created () {
    this.$nextTick(() => {
      this.value.calculate = {
        id: 'count',
        name: 'Cantidad'
      }
    })
  }
}
</script>
